import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedUiLibraryModule } from '@cudirect/shared-ui-library';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AppStatusComponent } from './component/app-status/app-status.component';
import { ContentLoaderComponent } from './component/content-loader/content-loader.component';
import { FacebookContentLoaderComponent } from './component/content-loader/facebook-loader.component';
import { UserDropdownComponent } from './component/user-dropdown/user-dropdown.component';
import { DocumentESignService } from './service/document-esign.service';
import { HangTightBannerComponent } from './component/hang-tight-banner/hang-tight-banner.component';
import { ESignDocumentReviewComponent } from './component/esign-document-review/esign-document-review.component';
import { LoginComponent } from './component/login/login.component';
import { ProductImageComponent } from './component/product-image/product-image.component';
import { CrossSellComponent } from './component/cross-sell/cross-sell.component';
import { CrossSellCardComponent } from './component/cross-sell/cross-sell-card/cross-sell-card.component';
import { OverviewBannerComponent } from './component/overview-banner/overview-banner.component';
import { FooterComponent } from './component/footer/footer.component';
import { VerifyComponent } from './component/verify/verify.component';
import { ReplacePipe } from './pipe/replace.pipe';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { EaAuthenticateModule } from '@cudirect-widgets/ea-login';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import { EcpSharedModule } from '@workflow/ecp-shared/shared.module';
import { ApiService } from '@workflow/ecp-shared/service/api/api.service';
import { SubscriptionEmitService } from '@workflow/ecp-shared/service/subscription-emit/subscription-emit.service';
import { ICheckGatewayComponent } from './component/icheck-gateway/icheck-gateway.component';
import { UserSessionComponent } from './component/user-session/user-session.component';
import { InstatouchComponent } from './component/instatouch/instatouch.component';
import { CodeInputModule } from 'angular-code-input';
import { ConsentComponent } from './component/consent/consent.component';
import { MigratedApplicationComponent } from './custom-modals/migrated-application.component';
import { UtilitiesService } from './service/utilities.service';
import { WorkflowLoaderComponent } from './component/workflow-loader/workflow-loader.component';
import { NumberToArrayPipe } from './pipe/numberToArray.pipe';
import { CheckAppAnimationComponent } from './animations/check-app-animation/check-app-animation.component';

/**
 * Notes from Refactor 3/26:
 * Messages component and All Pipes remain in @cudirect/shared-ui-library, so they have been removed from this file.
 * CUSpinner was also left inside of @cudirect/shared-ui-library in here until we can evaluate
 */
@NgModule({
  declarations: [
    AppStatusComponent,
    ContentLoaderComponent,
    FacebookContentLoaderComponent,
    UserDropdownComponent,
    HangTightBannerComponent,
    ESignDocumentReviewComponent,
    FooterComponent,
    LoginComponent,
    ProductImageComponent,
    CrossSellComponent,
    CrossSellCardComponent,
    OverviewBannerComponent,
    VerifyComponent,
    ICheckGatewayComponent,
    UserSessionComponent,
    InstatouchComponent,
    ConsentComponent,
    MigratedApplicationComponent,
    WorkflowLoaderComponent,
    CheckAppAnimationComponent
  ],
  exports: [
    SharedUiLibraryModule,
    AppStatusComponent,
    ContentLoaderComponent,
    FacebookContentLoaderComponent,
    UserDropdownComponent,
    EcpSharedModule,
    HangTightBannerComponent,
    ESignDocumentReviewComponent,
    FooterComponent,
    LoginComponent,
    ProductImageComponent,
    CrossSellComponent,
    CrossSellCardComponent,
    OverviewBannerComponent,
    VerifyComponent,
    ICheckGatewayComponent,
    UserSessionComponent,
    InstatouchComponent,
    ConsentComponent,
    MigratedApplicationComponent,
    WorkflowLoaderComponent,
    CheckAppAnimationComponent
  ],
  imports: [
    A11yModule,
    CommonModule,
    ReplacePipe,
    FormsModule,
    ReactiveFormsModule,
    CodeInputModule.forRoot({
      codeLength: 6,
      isCharsCode: false
    }),
    RouterModule,
    SharedUiLibraryModule,
    PdfViewerModule,
    EcpSharedModule,
    NgxMaskDirective,
    NgxMaskPipe,
    NumberToArrayPipe,
    EaAuthenticateModule
  ],
  providers: [ApiService, DocumentESignService, UtilitiesService]
})
export class SharedModule {
  public static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [SubscriptionEmitService, provideNgxMask()]
    };
  }
}
